import { User } from '../types';

const ADMIN_EMAILS = (import.meta.env.VITE_ADMIN_EMAILS || '')
  .split(',')
  .map((email: string) => email.trim().toLowerCase())
  .filter(Boolean);

const ADMIN_AUTH_KEY = 'cobalt_admin_auth';

export const isAdminUser = (user: User | null): boolean => {
  if (!user?.email) return false;
  return ADMIN_EMAILS.includes(user.email.trim().toLowerCase());
};

export const getStoredAdminAuth = () => {
  try {
    const raw = localStorage.getItem(ADMIN_AUTH_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.email || !parsed?.password) return null;
    return parsed as { email: string; password: string };
  } catch {
    return null;
  }
};

export const storeAdminAuth = (email: string, password: string) => {
  localStorage.setItem(ADMIN_AUTH_KEY, JSON.stringify({ email, password }));
};

export const clearAdminAuth = () => {
  localStorage.removeItem(ADMIN_AUTH_KEY);
};
